import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { Image } from 'ui'
import {
  SearchBar,
  SearchBarContainer,
  SearchInput,
  FilterButton,
  FilterImageIcon,
} from './Protocols.styles'
import SearchIcon from 'assets/icons/Search.svg'
import FilterIcon from 'assets/icons/ims/Filter.svg'

type Props = {
  filterActive: boolean
  onFilterToggle: () => void
  onSearch: (value: string) => void
}

const ProtocolsSearchBar: FC<Props> = ({ filterActive, onFilterToggle, onSearch }) => {
  const { t } = useTranslation('protocols')

  return (
    <SearchBar>
      <SearchBarContainer>
        <SearchInput
          role='search'
          placeholder={t`search_placeholder`}
          variant="outlined"
          InputProps={{ startAdornment: <Image src={SearchIcon} /> }}
          onChange={e => onSearch(e.currentTarget.value)}
        />
        <FilterButton
          active={filterActive}
          onClick={onFilterToggle}
          startIcon={<FilterImageIcon active={filterActive} src={FilterIcon} />}
        >{t`advanced_search`}</FilterButton>
      </SearchBarContainer>
    </SearchBar>
  )
}

export default observer(ProtocolsSearchBar)
